export var createCsatSettingsApi = function (baseUrl, http) {
    var csatSettingsUrl = baseUrl + "/csat";
    var csatServerUrl = "/apps/survey";
    var getLocaleUrl = function (locale) { return csatSettingsUrl + "/" + locale; };
    return {
        getGeneralSettings: function () { return http.get(csatSettingsUrl); },
        enableLocale: function (locale) { return http.put(getLocaleUrl(locale) + "/enable", {}); },
        disableLocale: function (locale) { return http.put(getLocaleUrl(locale) + "/disable", {}); },
        setCsatDelay: function (delayMinutes) { return http.put(csatSettingsUrl + "/delay", { delayMinutes: delayMinutes }); },
        setCsatThrottling: function (throttlingMinutes) { return http.put(csatSettingsUrl + "/throttling", { throttlingMinutes: throttlingMinutes }); },
        setCsatConditions: function (dto) { return http.put(csatSettingsUrl + "/conditions", dto); },
        setDisableMultipleCsatsPerTicket: function (enabled) { return http.put(csatSettingsUrl + "/multipleCsats/enable", { enabled: enabled }); },
        getLocaleSettings: function (locale) { return http.get(getLocaleUrl(locale)); },
        enableChannel: function (locale, channel) {
            return http.put(getLocaleUrl(locale) + "/channel/enable", { channel: channel, enabled: true });
        },
        disableChannel: function (locale, channel) {
            return http.put(getLocaleUrl(locale) + "/channel/enable", { channel: channel, enabled: false });
        },
        setInvitationMessage: function (locale, channel, invitationMessage) {
            return http.put(getLocaleUrl(locale) + "/invitationMessage", { channel: channel, invitationMessage: invitationMessage });
        },
        setCsatSurveyContent: function (locale, content) {
            return http.put(getLocaleUrl(locale) + "/content", { content: content });
        },
        getDefaultTranslations: function (locale) {
            return http.get(csatServerUrl + "/translations/" + locale);
        },
    };
};
//# sourceMappingURL=index.js.map